// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

ion-content {
  flex: 1;
}

.admin-menu-list {
  padding: 8px;
}
.admin-menu-list ion-item {
  --border-radius: 8px;
  margin-bottom: 2px;
  font-size: 0.95rem;
}
.admin-menu-list ion-icon {
  font-size: 20px;
  margin-inline-end: 16px;
}
.admin-menu-list ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.18);
  font-weight: 600;
}
.admin-menu-list ion-item.selected ion-icon {
  color: var(--kiwi-accent-text);
}
.admin-menu-list ion-item.group-selected {
  font-weight: 600;
}
.admin-menu-list ion-item.group-selected ion-icon {
  color: var(--kiwi-accent-text);
}
.admin-menu-list ion-icon.chevron {
  font-size: 16px;
  margin-inline-end: 0;
  opacity: 0.6;
}
.admin-menu-list .sub-items {
  margin: 2px 0 6px 18px;
  padding-left: 8px;
  border-left: 1px solid rgba(var(--kiwi-text-rgb), 0.12);
}
.admin-menu-list ion-item.sub-item {
  font-size: 0.88rem;
  --min-height: 38px;
}
.admin-menu-list ion-item.sub-item ion-icon {
  font-size: 17px;
  margin-inline-end: 12px;
}

.section-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  width: 100%;
  margin: 14px 0 4px;
  padding: 4px 8px;
  border: none;
  background: transparent;
  color: var(--ion-text-color);
  text-align: left;
  cursor: pointer;
}
.section-head .section-title {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  opacity: 0.75;
}
.section-head .section-hint {
  flex: 1;
  font-size: 0.72rem;
  opacity: 0.45;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.section-head ion-icon {
  font-size: 14px;
  margin: 0;
  opacity: 0.5;
}

ion-footer .admin-menu-list {
  border-top: 1px solid rgba(var(--kiwi-text-rgb), 0.1);
}`, "",{"version":3,"sources":["webpack://./src/app/components/core/admin-side-menu/admin-side-menu.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAAF;;AAGA;EACE,OAAA;AAAF;;AAGA;EACE,YAAA;AAAF;AAEE;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,eAAA;EACA,uBAAA;AADJ;AAKE;EACE,sDAAA;EACA,gBAAA;AAHJ;AAKI;EACE,8BAAA;AAHN;AAQE;EACE,gBAAA;AANJ;AAQI;EACE,8BAAA;AANN;AAUE;EACE,eAAA;EACA,oBAAA;EACA,YAAA;AARJ;AAYE;EACE,sBAAA;EACA,iBAAA;EACA,uDAAA;AAVJ;AAaE;EACE,kBAAA;EACA,kBAAA;AAXJ;AAaI;EACE,eAAA;EACA,uBAAA;AAXN;;AAiBA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAdF;AAgBE;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;AAdJ;AAiBE;EACE,OAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAfJ;AAkBE;EACE,eAAA;EACA,SAAA;EACA,YAAA;AAhBJ;;AAoBA;EACE,qDAAA;AAjBF","sourcesContent":["// content of the ion-menu in app.component.html: header, scrolling list, footer over the full height\n:host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\nion-content {\n  flex: 1;\n}\n\n.admin-menu-list {\n  padding: 8px;\n\n  ion-item {\n    --border-radius: 8px;\n    margin-bottom: 2px;\n    font-size: 0.95rem;\n  }\n\n  ion-icon {\n    font-size: 20px;\n    margin-inline-end: 16px;\n  }\n\n  // the page of the entry is open\n  ion-item.selected {\n    --background: rgba(var(--ion-color-primary-rgb), 0.18);\n    font-weight: 600;\n\n    ion-icon {\n      color: var(--kiwi-accent-text);\n    }\n  }\n\n  // group with an open page in its second level\n  ion-item.group-selected {\n    font-weight: 600;\n\n    ion-icon {\n      color: var(--kiwi-accent-text);\n    }\n  }\n\n  ion-icon.chevron {\n    font-size: 16px;\n    margin-inline-end: 0;\n    opacity: 0.6;\n  }\n\n  // second level: indented, a little smaller\n  .sub-items {\n    margin: 2px 0 6px 18px;\n    padding-left: 8px;\n    border-left: 1px solid rgba(var(--kiwi-text-rgb), 0.12);\n  }\n\n  ion-item.sub-item {\n    font-size: 0.88rem;\n    --min-height: 38px;\n\n    ion-icon {\n      font-size: 17px;\n      margin-inline-end: 12px;\n    }\n  }\n}\n\n// section by role\n.section-head {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  width: 100%;\n  margin: 14px 0 4px;\n  padding: 4px 8px;\n  border: none;\n  background: transparent;\n  color: var(--ion-text-color);\n  text-align: left;\n  cursor: pointer;\n\n  .section-title {\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    opacity: 0.75;\n  }\n\n  .section-hint {\n    flex: 1;\n    font-size: 0.72rem;\n    opacity: 0.45;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  ion-icon {\n    font-size: 14px;\n    margin: 0;\n    opacity: 0.5;\n  }\n}\n\nion-footer .admin-menu-list {\n  border-top: 1px solid rgba(var(--kiwi-text-rgb), 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
